import React from "react"
import { useSelector } from "react-redux"
import { Row, Col } from "react-bootstrap"

import Images from "assets/images"
import {
    StoreType,
    moduleIds,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    PageForm,
    Logo,
} from "client/components"

import NotFound from "client/parts/notFound"

const Home = () => {
    const moduleList = useSelector((state: StoreType) => state.module.moduleList)
    const markovModule = moduleList[moduleIds.markov]

    if (!markovModule) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{markovModule.name}</PageTitle>
            </PageHeader>
            <PageContent>
                <PageForm>
                    <Row>
                        <Col xs={12} md={3}>
                            <Logo logo={markovModule.logo || Images.defaultLogo} />
                        </Col>
                        <Col xs={12} md={9}>
                            <p>A probabilistic calculation tool</p>
                            <p>
                                Tool is based on the work of the Russian mathematician Andrei Markov.
                                The Markov technique can be used for a variety of applications and industries.
                                Google uses Markov for example to rank search results.
                                The financial industry uses Markov to model the markets and predict price movements.
                                Markov is often a major component in speech recognition software.
                                And in the risk, reliability, and safety industry Markov is used to make decision and probabilistic models.
                            </p>
                            <p>
                                “The background of the tool comes from the safety industry.”
                                explains Dr. Houtermans, Managing Partner at Risknowlogy.
                                “We developed it to model safety-related systems, like SIS,
                                and to make PFD calculations which are required by standards like IEC 61508,
                                61511 and other functional safety standards.
                                Today we use it to support decisions in complex risk and reliability models for the insurance,
                                financial, oil & gas and the process industry.”
                            </p>
                            <p>
                                The tool was developed with the user in mind. It has a graphical user interface which allows the user
                                to create a graphical model or the same model in table format. Furthermore the tool separates the model
                                from the data used which means that the user can calculate different scenarios based on different data.
                                The results of the calculations can be analyzed numerically, graphically, with analyzers and inspectors.
                            </p>
                        </Col>
                    </Row>
                </PageForm>
            </PageContent>
        </Container>
    )
}
export default Home
